<script lang="ts">
  import BlogIcon from "$lib/components/blog/blog-icons.svelte";
  import TOC from "$lib/components/blog/toc.svelte";
  import Tabs from "$lib/components/blog/tabs.svelte";
  import Banner from "$lib/components/blog/banner.svelte";
  import CompanyLogo from "$lib/components/basic/companyLogo/company-logo.svelte";
  import type { LayoutData } from "./$types";
  import { page } from "$app/stores";

  export let data: LayoutData;

  $: isPersonDetail = !!$page.params.peopleSlug;
  $: slug = $page.params.slug;
  $: tabs = [
    { name: "About", href: `/companies/${slug}` },
    { name: "Employees", href: `/companies/${slug}/people` },
    // { name: "Searches", href: `/companies/${slug}/search` },
  ];
</script>

{#if isPersonDetail}
  <slot />
{:else}
  <div
    class="h-[160px] bg-blog-gray-50 bg-cover bg-center dark:bg-blog-gray-950 lg:h-[280px]"
    style="background-image: url('/company-bg.jpg')"
  ></div>

  <div class="mx-auto flex max-w-7xl flex-col-reverse px-4 pt-16 lg:flex-row lg:pb-[6.625rem]">
    <div class="mt-12 lg:mt-0 lg:w-[28%]">
      <Banner link={`/chat-linkedin-profile/${encodeURIComponent(data.linkedin)}`} />
      <!-- <Newsletter /> -->
    </div>

    <div class="lg:w-[72%] lg:pl-16">
      <div class="mb-8 inline-flex min-w-[23.5rem] items-center gap-4 rounded-md border border-[#DFDFDF] p-4 lg:mb-12">
        <CompanyLogo imageUrl={data.smallLogoThumbUrl} altText={data.name} outline wrapperClass="w-12 h-12" />
        <div class="">
          <h1 class="text-[1.375rem] font-bold leading-[2rem]">{data.name}</h1>
          <div class="flex items-center gap-3">
            <a
              href={`https://${data.domain}`}
              class="transition-default text-sm leading-[1.25rem] underline hover:text-theme-green-deep"
              target="_blank"
            >
              {data.domain}
            </a>
            {#if data.linkedin}
              <a href={data.linkedin} class="text-[12px] leading-[17.6px]" target="_blank">
                <BlogIcon name="linkedin" size={16} />
              </a>
            {/if}
          </div>
        </div>
      </div>

      <TOC css="mt-12 lg:hidden" />
      <Tabs {tabs} />

      <slot />
    </div>
  </div>
{/if}
